import { render } from "./Variable.vue?vue&type=template&id=f16aea16&scoped=true"
import script from "./Variable.vue?vue&type=script&lang=js"
export * from "./Variable.vue?vue&type=script&lang=js"

import "./Variable.vue?vue&type=style&index=0&id=f16aea16&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f16aea16"]])

export default __exports__